import React, { useRef } from "react";
import { useState } from "react";
import { withTranslation } from "react-i18next"
import "./styles/FormContact.css"
import { Toaster, toast } from "react-hot-toast"

let pathBack = "https://back.jedify.io"
function FormContact(props) {
    const { t } = props
    const form = useRef()
    // const form2 = useRef()
    const [nameFile, setNameFile] = useState("")
    const [formOption, setFormOption] = useState(true)


    function sendIt(e) {
        e.preventDefault()
        form.current.focus()
        let data = new FormData(form.current)
        if (nameFile === "") return (
            toast.error(t("Message.Toast.FormContact.False.Empty"), {
                duration: 5000,
                style: {
                    backgroundColor: "#f09236",
                    color: "white",
                    fontWeight: "bold"
                }
            }))
        let file = data.get("cv")
        let extention = file.name.split(".")
        if (file.size >= 3000000) return (
            toast.error(t("Message.Toast.FormContact.False.Size"), {
                duration: 5000,
                style: {
                    backgroundColor: "#f09236",
                    color: "white",
                    fontWeight: "bold"
                }
            }))
        if (extention[extention.length - 1] !== "pdf") return (
            toast.error(t("Message.Toast.FormContact.False.Format"), {
                duration: 5000,
                style: {
                    backgroundColor: "#f09236",
                    color: "white",
                    fontWeight: "bold"
                }
            }))

        const options = {
            method: 'POST',
            body: data
        };

        fetch(pathBack + "/api/send/it", options)
            .then(res => res.json())
            .then(res => {
                setNameFile("")
                form.current.reset()
                res.success ? (
                    toast.success(t("Message.Toast.FormContact.True"), {
                        duration: 5000,
                        style: {
                            backgroundColor: "#f09236",
                            color: "white",
                            fontWeight: "bold"
                        }
                    })
                ) : (
                    toast.error(t("Message.Toast.FormContact.False"), {
                        duration: 5000,
                        style: {
                            backgroundColor: "#f09236",
                            color: "white",
                            fontWeight: "bold"
                        }
                    })
                )
            }).catch(() => {
                toast.error(t("Message.Toast.FormContact.False"), {
                    duration: 5000,
                    style: {
                        backgroundColor: "#f09236",
                        color: "white",
                        fontWeight: "bold"
                    }
                })
            })
    }
    function sendEm(e) {
        e.preventDefault()
        form.current.focus()
        let data = new FormData(form.current)
        const options = {
            method: 'POST',
            body: data
        };

        fetch(pathBack + "/api/send/empresa", options)
            .then(res => res.json())
            .then(res => {
                form.current.reset()
                res.success ? (
                    toast.success(t("Message.Toast.FormContact.True"), {
                        duration: 5000,
                        style: {
                            backgroundColor: "#f09236",
                            color: "white",
                            fontWeight: "bold"
                        }
                    })
                ) : (
                    toast.error(t("Message.Toast.FormContact.False"), {
                        duration: 5000,
                        style: {
                            backgroundColor: "#f09236",
                            color: "white",
                            fontWeight: "bold"
                        }
                    })
                )
            }).catch((err) => {
                toast.error(t("Message.Toast.FormContact.False"), {
                    duration: 5000,
                    style: {
                        backgroundColor: "#f09236",
                        color: "white",
                        fontWeight: "bold"
                    }
                })
            })
    }
    function name(e) {
        e.preventDefault()
        let name = e.target.value.split("\\")
        setNameFile(name[name.length - 1])
    }

    return (

        <section className="sumate">
            <Toaster
                position="bottom-right"
            />
            <div className="divSumateTitulo">
                <h3 onClick={() => setFormOption(true)} className={`tituloIt  ${formOption ? "tituloActive" : ""}`}>{t('Sumate.titulo.it')}</h3>
                <h3 onClick={() => setFormOption(false)} className={`tituloIt ${formOption ? "" : "tituloActive"}`}>{t('Sumate.titulo.em')}</h3>
            </div>
            {formOption ? (
                <div className="formContainer">
                    <div className="textContainer">
                        <h3 className="tituloForm">{t('Sumate.tituloh4.2')}</h3>
                        <p className="textForm">
                            {t('Sumate.pa')}
                        </p>
                    </div>

                    <form className="formulario" onSubmit={(e) => sendIt(e)} ref={form}>
                        <input required className="inputContact" type="text" placeholder={t("Form.input.name")} id="name" name="name" />
                        <input required className="inputContact" type="text" placeholder={t("Form.input.Email.it")} id="email" name="email" />
                        <label className="labelFile" htmlFor="cv"><span className="spanAñadir">+</span>{" " + t("From.cv")} (.pdf)<span style={{ color: "black" }}> {" " + nameFile}</span></label>
                        <input onChange={(e) => name(e)} type="file" id="cv" name="cv" />
                        <button type="submit" className="botonSubmit" >{t("Form.SendBtn")}</button>
                    </form>
                </div>
            ) : (
                <div className="formContainer">
                    <div className="textContainer">

                        <h3 className="tituloForm">{t('Footer.h5.3')}</h3>
                        <p className="textForm">
                            {t('Footer.p3')}
                        </p>
                    </div>

                    <form className="formulario" onSubmit={(e) => sendEm(e)} ref={form}>
                        <input required className="inputContact" type="text" placeholder={t("Form.input.name")} id="name" name="name" />
                        <input required className="inputContact" type="text" placeholder={t("Form.input.Email.empresa")} id="email" name="email" />
                        <textarea className="inputContact" name="message" id="message" cols="30" rows="2" placeholder={t("Form.input.textArea")} style={{ resize: "vertical" }}></textarea>
                        <button type="submit" className="botonSubmit" >{t("Form.SendBtn")}</button>
                    </form>
                </div>
            )}
        </section >

    )


}


export default withTranslation()(FormContact)
